import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumExternalServer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-medium-external-server_svg__Layer_1"
    x={0}
    y={0}
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".spaces-medium-external-server_svg__st0{fill:#676767}"}</style>
    <path
      id="spaces-medium-external-server_svg__Line3_3_"
      className="spaces-medium-external-server_svg__st0"
      d="M16 15h2v1h-2z"
    />
    <path
      id="spaces-medium-external-server_svg__Line2_3_"
      className="spaces-medium-external-server_svg__st0"
      d="M16 10h2v1h-2z"
    />
    <path
      id="spaces-medium-external-server_svg__Line1_3_"
      className="spaces-medium-external-server_svg__st0"
      d="M18 5h-2v1h2z"
    />
    <path
      id="spaces-medium-external-server_svg__ServerOutline_2_"
      className="spaces-medium-external-server_svg__st0"
      d="M20 4c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .2.1.4.2.5-.1.1-.2.3-.2.5v4c0 .6.4 1 1 1h15c.6 0 1-.4 1-1v-4c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V9c0-.2-.1-.4-.2-.5.1-.1.2-.3.2-.5V4zM4 4h15v4H4V4zm15 9H4V9h15v4zm0 5H4v-4h15v4z"
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumExternalServer);
export default Memo;
